import { render, staticRenderFns } from "./importacao.vue?vue&type=template&id=e8838d42&scoped=true"
import script from "./importacao.vue?vue&type=script&lang=js"
export * from "./importacao.vue?vue&type=script&lang=js"
import style0 from "./importacao.vue?vue&type=style&index=0&id=e8838d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8838d42",
  null
  
)

export default component.exports